module.exports = __webpack_public_path__ + "c75cba6cd9b57d547775500d00616b72.svg";